// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { GetLedgersApiParameter } from "@store/Framework/Services/LedgerService";
import BillingStatusState from "@store/Framework/Store/Store/Pages/BillingStatus/BillingStatusState";
import { Draft } from "immer";

const initialState: BillingStatusState = {
    getLedgersParameter: {
        page: 1,
    },
    filtersOpen: false,
};

const actions = {
    "Store/Pages/BillingStatus/UpdateSearchFields": (
        draft: Draft<BillingStatusState>,
        action: { parameter: GetLedgersApiParameter & UpdateSearchFieldsType },
    ) => {
        const { type } = action.parameter;
        delete action.parameter.type;
        if (type === "Replace") {
            draft.getLedgersParameter = action.parameter;
        } else if (type === "Initialize") {
            draft.getLedgersParameter = { ...initialState.getLedgersParameter, ...action.parameter };
        } else {
            draft.getLedgersParameter = { ...draft.getLedgersParameter, ...action.parameter };

            for (const key in draft.getLedgersParameter) {
                const value = (<any>draft.getLedgersParameter)[key];

                // remove empty parameters
                if (value === "" || value === undefined) {
                    delete (<any>draft.getLedgersParameter)[key];
                }
            }

            for (const key in action.parameter) {
                // go back to page 1 if any other parameters changed
                if (
                    draft.getLedgersParameter.page &&
                    draft.getLedgersParameter.page > 1 &&
                    key !== "page" &&
                    key !== "pageSize"
                ) {
                    draft.getLedgersParameter.page = 1;
                }
            }
        }

        if (Object.keys(draft.getLedgersParameter).length === 0) {
            draft.getLedgersParameter = { page: 1 };
        }
    },
    "Store/Pages/BillingStatus/ClearParameter": (draft: Draft<BillingStatusState>) => {
        draft.getLedgersParameter = {
            ...initialState.getLedgersParameter,
            pageSize: draft.getLedgersParameter.pageSize,
            query: draft.getLedgersParameter.query,
        };
    },
    "Store/Pages/BillingStatus/ToggleFiltersOpen": (draft: Draft<BillingStatusState>) => {
        draft.filtersOpen = !draft.filtersOpen;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type BillingStatusActions = Parameters<typeof reducer>[1];
export default reducer;
